import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-84">
      <div className="glass-card rounded-3xl p-8 md:p-12 border border-brand-gold/50 text-center relative overflow-hidden" data-id="element-85">
        <div className="absolute -top-10 -right-10 text-brand-gold/10" data-id="element-86">
          <ShieldCheck className="w-64 h-64" data-id="element-87" />
        </div>

        <div className="relative z-10" data-id="element-88">
          <div className="bg-brand-gold/20 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-89">
            <ShieldCheck className="w-10 h-10 text-brand-gold" data-id="element-90" />
          </div>

          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-91">
            Garantía Incondicional de 45 Días
          </h2>

          <p className="text-xl text-gray-300 mb-6" data-id="element-92">
            Prueba el Megapack completo. Si no es lo que esperabas, te hacemos
            la{' '}
            <span className="text-brand-gold font-bold" data-id="element-93">
              devolución de tu dinero
            </span>
            .
          </p>

          <p className="text-2xl font-bold text-white" data-id="element-94">
            Sin preguntas. Sin complicaciones.
          </p>
        </div>
      </div>
    </section>;
}